import type { PaymentMethod } from "@/lib/types";
import { formatEuro } from "@/lib/format";

export function PaymentQuickAnswer({ method }: { method: PaymentMethod }) {
  return (
    <section aria-labelledby="snel-antwoord" className="mt-8 border-y border-border py-6">
      <h2 id="snel-antwoord" className="text-xl font-semibold text-foreground">
        Kort antwoord: betalen met {method.name}
      </h2>
      <p className="mt-3 text-[15px] leading-7 text-muted-foreground">
        {method.intro} De algemene minimumstorting is {formatEuro(method.min_deposit_general)};
        de kassa van de aanbieder kan een ander minimum hanteren. Storten: {method.typical_deposit_speed ?? "controleer de kassa"}.
      </p>
      <p className="mt-2 text-[15px] leading-7 text-muted-foreground">
        {method.withdrawal_supported
          ? `Opnemen kan bij ondersteunende aanbieders; de gebruikelijke route is: ${method.typical_withdrawal_speed ?? "controleer de opnamevoorwaarden"}. Een stortoptie garandeert geen opnameoptie.`
          : `Je kunt niet rechtstreeks opnemen met ${method.name}. Controleer vóór het storten de aparte bank- of walletuitbetaling.`}
        {" "}Kosten: {method.typical_fees ?? "controleer de actuele tarieven"}. Betaal alleen met eigen geld en binnen je vastgestelde speelbudget.
      </p>
    </section>
  );
}